import {
    acceptAllCookies,
    acceptAnalyticsCookies, acceptBasicCookies,
    getCookie, showModalConfigCookies,
    showModalCookies
} from "../../webpack/modules-optimized/cookies";
import {clickEvent, dispatchCustomEvent} from "../../webpack/modules/events";
import {hideModal} from "../../webpack/modules-optimized/modal";
import {showNewsletterPopup} from "../../webpack/modules-optimized/newsletter";

let cookieChoice = getCookie('_tv_cookie_choice');
let cookieCountry = sessionStorage.getItem('_tv_user_cookie_country') === 'true';

if (!cookieChoice && cookieCountry) showModalCookies();

clickEvent('.accept-all-cookies', true, function() {
    hideModal('modal-cookies');
    dispatchCustomEvent('userCookiesSelected', {});
    queueMicrotask(() => acceptAllCookies(365));
    setTimeout(showNewsletterPopup, 150);
});

clickEvent('.decline-all-cookies', true, function() {
    hideModal('modal-cookies');
    dispatchCustomEvent('userCookiesSelected', {});
    setTimeout(showNewsletterPopup, 150);
    queueMicrotask(function() {
        acceptAnalyticsCookies(365);
        acceptBasicCookies(365);
    });
});

clickEvent('.show-modal-config-cookies', true, function() {
    hideModal('modal-cookies');
    showModalConfigCookies();
});
